import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
  useAddFertilizerUsageMutation,
  useDeleteFertilizerUsageMutation,
  useEditFertilizerUsageMutation
} from "../../../../redux/api/chemicalization/fertilizerUsage";
import { EntFertilizerUsage } from "../../../../models/chemicalization/fertilizerUsage";


const useFertilizerUsage = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [ addFertilizerUsage] = useAddFertilizerUsageMutation();
  const [ deleteFertilizerUsage ] = useDeleteFertilizerUsageMutation();
  const [ editFertilizerUsage ] = useEditFertilizerUsageMutation();

  async function onAddFertilizerUsage(newFertilizerUsage: EntFertilizerUsage): Promise<boolean> {
    try {
      let status: boolean = false;
      await addFertilizerUsage(newFertilizerUsage).then((response: any) => {
        if (response.error !== undefined) {

          throw new Error(response.error.data.message);
        }
        if (response.data.success) {
          status = true;
          message.success(t('msg.successAdd'));
          if (refresh) refresh();
        }
      }).catch((error: any) => {
        modal.error({ title: t('msg.error'), content: String(error.message) });

      });
      return status;
    } catch (error: any) {
      modal.error({ title: t('msg.error'), content: String(error.message) });
      return false;
    }
  }

  async function onDeleteFertilizerUsage(fertilizerUsage: EntFertilizerUsage) {
    try {
      let status: boolean = false;
      confirm({
        centered: true,
        title: t('msg.confirmDeleteText'),
        okText: t('general.yes'),
        cancelText: t('general.no'),
        onOk() {
          deleteFertilizerUsage(fertilizerUsage.id as number).then((response: any) => {
            if (response.error !== undefined && response.error.status === 400) {
              status = false;
              throw new Error(response.error.data.message);
            }
            if (response.data.success) {
              status = true;
              Modal.success({ title: t('msg.successDelete') });
              if (refresh) refresh();
            }
          }).catch((error: any) => {
            Modal.error({ title: t('msg.error'), content: String(error.message) });

          });
        }
      })
      return status
    } catch (error: any) {
      Modal.error({ title: t("msg.error"), content: String(error.message) });
      return false;
    }
  }

  async function onEditFertilizerUsage(editedFertilizerUsage: EntFertilizerUsage): Promise<boolean> {
    try {
      let status: boolean = false;
      await editFertilizerUsage(editedFertilizerUsage).then((response: any) => {
        if (response.error !== undefined && response.error.status === 400) {
          throw new Error(response.error.data.message);
        }
        if (response.data.success) {
          status = true;
          Modal.success({ title: t('msg.successEdited') });
          if (refresh) refresh();
        }
      }).catch((error: any) => {
        Modal.error({ title: t('msg.error'), content: String(error.message) });
      });
      return status;
    } catch (error: any) {
      Modal.error({ title: t("msg.error"), content: String(error.message) });
      return false;
    }
  }

  return { onAddFertilizerUsage, onDeleteFertilizerUsage, onEditFertilizerUsage };

}
export { useFertilizerUsage };

